import { render, staticRenderFns } from "./WorkOrderBoard.vue?vue&type=template&id=24b82fd0&scoped=true&"
import script from "./WorkOrderBoard.vue?vue&type=script&lang=js&"
export * from "./WorkOrderBoard.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderBoard.vue?vue&type=style&index=0&id=24b82fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b82fd0",
  null
  
)

export default component.exports